import React from 'react'; //, { Component }

class InfoGraphic extends React.Component {
  render() {
      return (
        <svg className="info-graphic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 440 440"><g><g><line className="cls-1" x1="10.76" y1="429.24" x2="10.76" y2="429.24"/><line className="cls-2" x1="14.33" y1="425.67" x2="427.45" y2="12.55"/><line className="cls-1" x1="429.24" y1="10.76" x2="429.24" y2="10.76"/><line className="cls-1" x1="10.76" y1="10.76" x2="10.76" y2="10.76"/><line className="cls-2" x1="14.33" y1="14.33" x2="427.45" y2="427.45"/><line className="cls-1" x1="429.24" y1="429.24" x2="429.24" y2="429.24"/><circle className="cls-3" cx="220" cy="220" r="219.5"/><rect className="cls-3" x="65.06" y="65.06" width="309.89" height="309.89"/></g></g></svg>
      );
  }
}

export default InfoGraphic;



// WEBPACK FOOTER //
// ./src/svg/info-graphic.js